import React, { FC, FormEvent, ChangeEvent, MouseEvent } from "react";

import { SelectDateRangeButtons } from "~/components/organisms";

import { RangeDatePropsType } from "~/domains";

import { Button, Form, FormSubmitButton, TextField } from "~/ui";
import { TitleWithChild } from "~/ui";

type PropsType = {
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  onConditionReset: (e: MouseEvent<HTMLButtonElement>) => void;
  searchKeyword: {
    value: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  };
  date: {
    startDate: Date | null;
    endDate: Date | null;
    onChange: (value: RangeDatePropsType) => void;
  };
};

export const PrivateQuestionAnswerSearchForm: FC<PropsType> = ({
  onSubmit,
  onConditionReset,
  searchKeyword,
  date,
}: PropsType) => {
  return (
    <Form onSubmit={onSubmit} className="mt-6 space-y-6">
      <>
        <TitleWithChild title="期間指定">
          <SelectDateRangeButtons
            startDate={date.startDate}
            endDate={date.endDate}
            onChange={date.onChange}
            className="mt-3.5"
          />
        </TitleWithChild>
        <TitleWithChild title="フリーワード">
          <TextField
            value={searchKeyword.value}
            placeholder="キーワード"
            type="search"
            name="keyword"
            onChange={searchKeyword.onChange}
          />
        </TitleWithChild>
        <div className="space-x-4 flex">
          <Button
            color="gray"
            outline
            onClick={onConditionReset}
            className="w-full"
            text="リセット"
          />
          <FormSubmitButton
            value="検索する"
            color="primary"
            className="w-full"
          />
        </div>
      </>
    </Form>
  );
};
